import {
  ThemeProvider as NextThemesProvider,
  type ThemeProviderProps as NextThemesProviderProps,
} from 'next-themes'
import type { ReactElement, ReactNode } from 'react'

export type ThemeProviderProps = NextThemesProviderProps & {
  children: ReactNode
}

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  const Provider = NextThemesProvider as (
    props: ThemeProviderProps,
  ) => ReactElement
  return <Provider {...props}>{children}</Provider>
}
